import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiServices } from "../4.Utils/apiServices";

const namespace = "CompanySlice";

export const getCompanies = createAsyncThunk(
  `${namespace}/Companies`,
  async (body, { rejectWithValue }) => {
    const api = "get_company_lists";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getCompanyID = createAsyncThunk(
  `${namespace}/CompaniesID`,
  async ({cid}, { rejectWithValue }) => {
    const api = "get_company_id";
    const replace = { 
      search: "{company}",
      replace: cid
    };
    const opt = {
      replace: replace,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const updateCompanyID = createAsyncThunk(
  `${namespace}/updateCompaniesID`,
  async (body, { rejectWithValue }) => {
    const api = "update_company_id";
    const replace = { 
      search: "{company}",
      replace: body.id
    };
    const opt = {
      replace: replace,
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const deleteCompanyID = createAsyncThunk(
  `${namespace}/deleteCompaniesID`,
  async (body, { rejectWithValue }) => {
    const api = "delete_company";
    const replace = { 
      search: "{company}",
      replace: body.id
    };
    const opt = {
      replace: replace,
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const addCompany = createAsyncThunk(
  `${namespace}/addCompany`,
  async (body, { rejectWithValue }) => {
    const api = "add_company";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      console.log(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  company: {
    id: "",
    description: "",
    short_description: "",
  },
  companies: [],
  loading: false,
  error: false,
};

const CompanySlice = createSlice({
  name: namespace,
  initialState,
  reducers: {
    updateCompany(state, action) {
      return { ...state, company: action.payload };
    },

    resetList(state) {
      return {
        ...state, 
        company: initialState.company,
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompanies.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.companies = action.payload;
      })
      .addCase(getCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })

      .addCase(getCompanyID.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getCompanyID.fulfilled, (state, action) => {
        state.loading = false;
        state.company = action.payload;
      })
      .addCase(getCompanyID.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })

      .addCase(updateCompanyID.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateCompanyID.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateCompanyID.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })

      .addCase(addCompany.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addCompany.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })

      .addCase(deleteCompanyID.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteCompanyID.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteCompanyID.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      })
  },
});

export const { resetList, updateCompany } = CompanySlice.actions;
export default CompanySlice.reducer;